import apiClient from 'apiClient';
import { VulnerabilityId } from './Vulnerability';

const remove = async (apiPrefix: string, vulnerabilityId: VulnerabilityId): Promise<void> => {
  try {
    await apiClient.delete<void>(`${apiPrefix}/vulnerabilities/${vulnerabilityId}`);
  } catch (e) {
    throw new Error('Could not delete vulnerability.');
  }
};

export default remove;
